import * as React from "react";
import { handleLineBreaks } from "../helpers/prismicHelpers";
import "./cards.scss";
import { AppContext } from "../layout/shell";
export var Cards = function Cards(_ref) {
  var data = _ref.data,
      className = _ref.className;

  var _React$useContext = React.useContext(AppContext),
      isMobile = _React$useContext.isMobile;

  var hasBackgroundImage = !!data.primary.header_background_image && !isMobile;
  var style = hasBackgroundImage ? {
    backgroundImage: "url('" + data.primary.header_background_image["url"] + "')"
  } : {};
  var imageCopyright = data.primary.header_background_image && data.primary.header_background_image["copyright"];
  return /*#__PURE__*/React.createElement("div", {
    className: "cards " + (className || '') + " cards-" + data.primary.card_style + " " + data.primary.background_style + "-bg",
    "data-bgimage": hasBackgroundImage,
    style: style
  }, imageCopyright && /*#__PURE__*/React.createElement("p", {
    className: "image-copyright"
  }, imageCopyright), /*#__PURE__*/React.createElement("div", {
    className: "fixed-width"
  }, data.primary["header"] && /*#__PURE__*/React.createElement("h2", null, data.primary["header"]), /*#__PURE__*/React.createElement("div", {
    className: "cards-grid",
    style: {
      gridTemplateColumns: "repeat(" + data.primary.cards_per_row + ",1fr)"
    }
  }, data.fields.map(function (card) {
    return /*#__PURE__*/React.createElement("div", {
      className: "card"
    }, card.image && /*#__PURE__*/React.createElement("img", {
      src: card.image['url'],
      alt: card.image['alt']
    }), /*#__PURE__*/React.createElement("h4", null, handleLineBreaks(card.sub_header)), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement("h3", null, handleLineBreaks(card.header)), /*#__PURE__*/React.createElement("p", null, handleLineBreaks(card.body_copy)), /*#__PURE__*/React.createElement("hr", null));
  }))));
};